import { AllocateSingleId } from "../AllocateId";
import { GetMasterTableEntries } from "../GetMasterTableEntries";
import { DeleteFromServer, FetchFromServer, SaveToServer } from "../Post";

const MasterTableName = "GAAProjectCustomerLaundryItemMaster";
const FetchRequestType = "GAAProjectCustomerLaundryItemFetchRequest";

// Save All Data To Database //
export const SaveHotelLaundry = async (ref, payload) => {
  payload["Ref"] = await AllocateSingleId(ref);
  return await SaveToServer(payload, MasterTableName, []);
};
// Get All Data From Database //
export const GetHotelLaundryList = async () => {
  let payload = { Refs: [] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  result = result.sort((a, b) => a.Name.localeCompare(b.Name));
  return result;
};

// Get Single Data From Database //
export const GetHotelLaundry = async (Ref) => {
  let payload = {GAAProjectCustomerLaundryItemRefs: [Ref] };
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let resultList = GetMasterTableEntries(td, MasterTableName);
  if (resultList.length > 0) {
    return resultList[0];
  }
  return null;
};

export const DeleteHotelLaundry = async (payload) => {
  return await DeleteFromServer(payload, MasterTableName);
};

export const GetGAAHotelLaundryListByProject = async (projectRef) => {
  let payload = { GAAProjectRefs: [projectRef]};
  let td = await FetchFromServer(payload, FetchRequestType, []);
  let result = GetMasterTableEntries(td, MasterTableName);
  return result;
};

